import { Component } from 'react';
import { ReactComponent as Edit } from 'assets/images/svg/edit.svg';
import { toast as toastr } from 'react-toastify';

export default class EditButton extends Component {
  handleEdit = () => {
    const { getActiveEditData, ...rest } = this.props;
    if(!this.props.checkPermission) {
      toastr.error('You dont have permission to edit')
      return
    }
    this.props.getActiveEditData(rest);
  };

  render() {
    const { disable = false } = this.props;
    return (
      <>
        <button disabled={ (this.props.checkPermission && !disable) ? null : 'disabled' } onClick={ this.handleEdit }>
          <Edit />
        </button>
      </>
    );
  }
}
